import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Privilege} from '../../models/privilege';

@Component({
  selector: 'app-privilege-checkbox',
  templateUrl: './privilege-checkbox.component.html',
  styleUrls: ['./privilege-checkbox.component.scss']
})
export class PrivilegeCheckboxComponent {

  @Input() privilege: Privilege;
  @Input() editMode: boolean;

  @Output('checkboxChangeEvent') checkboxChangeEvent = new EventEmitter();

  constructor() { }

  /**
   * When a checkbox change update the privilege checked status and emit the event
   * @param event
   * @param {Privilege} privilege
   */
  checkboxChange(event, privilege: Privilege) {
    privilege.checked = event.checked;
    this.checkboxChangeEvent.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/privilege-checkbox/privilege-checkbox.component.ts